import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { SidekickBlock as Value } from "@reactivated";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows ``SidekickBlock`` (homepage / product-list
 * sidekick promo). DOM mirrors the legacy Django template
 * ``cms/components/homepage_sidekick.html`` exactly.
 *
 * Rendered regardless of ``sidekick_status`` (the
 * ``display-status--{status}`` class drives the CSS hide behaviour). All
 * text fields (``headline``/``description``/prices/``cart_link_name``) are
 * plain CharBlock strings. The strike/actual price spans are emitted flush
 * with no separating whitespace, matching the Django markup. The "VIEW
 * PRODUCT DETAILS" label is hardcoded in the template.
 */
export const SidekickBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        <div
            className={`l-capped-width sidekick display-status--${v.sidekick_status ?? ""}`}
        >
            <div className="sidekick-inner">
                <div className="sidekick__container sidekick__container--lima">
                    <div className="sidekick-info sidekick-info--pillows-landing">
                        <div className="sidekick-info-col1">
                            <div className="sidekick-info__subtitle">
                                {v.headline ?? ""}
                            </div>
                            <div className="sidekick-info__copy">
                                {v.description ?? ""}
                            </div>
                            <a href={v.details_link?.url ?? ""}>
                                <div className="sidekick-info__view_details">
                                    {t`VIEW PRODUCT DETAILS`}
                                </div>
                            </a>
                        </div>
                        <div className="sidekick-info-col2">
                            <div className="sidekick-info__price">
                                {v.starting_price ? (
                                    <span className="sidekick-info__price--strike">
                                        ${v.starting_price}
                                    </span>
                                ) : null}
                                <span className="sidekick-info__price__actual">
                                    ${v.retail_price ?? ""}
                                </span>
                            </div>
                            <div className="sidekick-info__link">
                                <a href={v.cart_link?.url ?? ""}>
                                    <div className="button button-conifer-pillows sidekick-info__button">
                                        {v.cart_link_name ?? ""}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="sidekick__main-image-container">
                        <img
                            src={v.image?.url ?? ""}
                            alt=""
                            className="sidekick__main-image sidekick__main-image--pillows-landing"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
